export default __webpack_public_path__ + "static/media/EM1190.34I-30808_-17639_0.da7581e1.jpg";